import { STORAGE_CONST } from '@common/constants'

export const saveRouteAndQuery = (pathname: string, search: string) => {
    localStorage.setItem(STORAGE_CONST.SAVED_ROUTE, pathname)
    localStorage.setItem(STORAGE_CONST.SAVED_QUERY, search)
}
